if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.checkboxes = [];
      this.addAllButton = null;
    }

    connectedCallback() {
      const initialRecommendations = this.querySelector('[data-recommendations]');
      if (initialRecommendations && initialRecommendations.children.length > 0) {
        this.initSlider();
        this.initCheckboxes();
        this.initSizeSelectors();
        this.initAddAllButton();
      }
      this.performRecommendations();
    }

    performRecommendations() {
      const recommendations = this.querySelector('[data-recommendations]');
      if (!recommendations) return;

      const url = this.dataset.url;
      if (!url) return;

      fetch(url)
        .then(response => response.ok ? response.text() : null)
        .then(text => {
          if (!text) return;

          const html = new DOMParser().parseFromString(text, 'text/html');

          // Extract recommendation items rendered by Shopify (excludes the "current product" item)
          const recItems = html.querySelectorAll(
            '.product-recommendations__item:not(.product-recommendations__item--current)'
          );

          if (!recItems.length) {
            // No complementary products returned — keep the component hidden entirely
            return;
          }

          // Append server-rendered recommendation items after the current product item
          recItems.forEach(item => recommendations.appendChild(item));

          this.classList.remove('hidden');

          var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if (cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('.cart-drawer-items__full');
          }

          // Re-initialise after content update
          this.initSlider();
          this.initCheckboxes();
          this.initSizeSelectors();
          this.initAddAllButton();

          setTimeout(() => {
            if (document.querySelector('quick-cart-drawer')) {
              document.querySelector('quick-cart-drawer').init();
            } else {
              this.querySelectorAll('.quick-cart-drawer__trigger').forEach(el => el?.remove());
            }
          }, 500);
        })
        .catch(error => {
          console.error('Error fetching complementary products:', error);
          if (this.querySelector('[data-recommendations]')?.children.length > 0) {
            this.classList.remove('hidden');
          }
        });
    }

    initSlider() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
        grabCursor: true,
      });
    }

    initCheckboxes() {
      this.checkboxes = Array.from(this.querySelectorAll('.product-recommendations__item-checkbox'));
      this.checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', () => {
          this.updateAddAllButtonState();
        });
        checkbox.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      });
      
      const labels = this.querySelectorAll('.product-recommendations__item-checkbox-label');
      labels.forEach(label => {
        label.addEventListener('click', (e) => {
          if (e.target === label || e.target.closest('.product-recommendations__item-checkbox')) {
            return;
          }
        });
      });
    }

    initSizeSelectors() {
      const sizeSelects = this.querySelectorAll('.product-recommendations__size-select');
      sizeSelects.forEach(select => {
        select.addEventListener('change', (e) => {
          e.stopPropagation();
          const variantId = e.target.value;
          const productId = e.target.dataset.productId;
          
          // Update the corresponding checkbox's variant ID
          const item = e.target.closest('.product-recommendations__item');
          if (item) {
            const checkbox = item.querySelector('.product-recommendations__item-checkbox');
            if (checkbox) {
              checkbox.dataset.productVariantId = variantId;
            }
          }
        });

        select.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
        });
      });
    }

    initAddAllButton() {
      this.addAllButton = this.querySelector('[data-add-all-to-cart]');
      if (this.addAllButton) {
        // Remove old listeners by cloning
        const newButton = this.addAllButton.cloneNode(true);
        this.addAllButton.parentNode.replaceChild(newButton, this.addAllButton);
        this.addAllButton = newButton;

        this.addAllButton.addEventListener('click', () => {
          this.addAllToCart();
        });
        this.updateAddAllButtonState();
      }
    }

    updateAddAllButtonState() {
      if (!this.addAllButton) return;
      const checkedCount = this.checkboxes.filter(cb => cb.checked).length;
      this.addAllButton.disabled = checkedCount === 0;
      this.updateCounter();
    }

    updateCounter() {
      const counter = this.querySelector('.product-recommendations__counter');
      if (!counter) return;
      const total = this.checkboxes.length;
      if (total === 0) { counter.textContent = ''; return; }
      const selected = this.checkboxes.filter(cb => cb.checked).length;
      counter.textContent = `${selected}/${total}`;
    }

    getSelectedVariantIds() {
      const items = [];
      
      this.checkboxes.filter(cb => cb.checked).forEach(cb => {
        const item = cb.closest('.product-recommendations__item');
        const sizeSelect = item?.querySelector('.product-recommendations__size-select');
        
        let variantId;
        if (sizeSelect && sizeSelect.value) {
          variantId = sizeSelect.value;
        } else {
          variantId = cb.dataset.productVariantId;
        }
        
        if (variantId) {
          items.push({ id: variantId, quantity: 1 });
        }
      });
      
      return items;
    }

    async addAllToCart() {
      if (!this.addAllButton) return;

      // Validate that all checked items with size selectors have a size selected
      const missingSize = [];
      this.checkboxes.filter(cb => cb.checked).forEach(cb => {
        const item = cb.closest('.product-recommendations__item');
        const sizeSelect = item?.querySelector('.product-recommendations__size-select');
        if (sizeSelect && !sizeSelect.value) {
          const title = item.querySelector('.product-recommendations__item-title')?.textContent?.trim() || 'a product';
          missingSize.push(title);
        }
      });

      if (missingSize.length > 0) {
        alert(`Please select a size for: ${missingSize.join(', ')}`);
        return;
      }

      const checkedProducts = this.getSelectedVariantIds();

      if (checkedProducts.length === 0) {
        alert('No available products selected. Some products may be out of stock.');
        return;
      }

      this.addAllButton.disabled = true;
      const loadingSpinner = this.addAllButton.querySelector('.product-recommendations__add-all-button--loading');
      if (loadingSpinner) loadingSpinner.style.display = 'block';
      this.addAllButton.style.opacity = '0.6';
      this.addAllButton.style.pointerEvents = 'none';

      try {
        const cartDrawer = document.querySelector('cart-drawer');

        // Build a single FormData with all items so we get one atomic cart add +
        // the section HTML back in the same response (same pattern as buy-the-look)
        const formData = new FormData();
        checkedProducts.forEach((product, index) => {
          formData.append(`items[${index}][id]`, product.id);
          formData.append(`items[${index}][quantity]`, product.quantity);
        });

        if (cartDrawer?.getSectionsToRender) {
          const sections = cartDrawer.getSectionsToRender().map(s => s.section);
          if (sections.length > 0) formData.append('sections', sections.join(','));
          formData.append('sections_url', window.location.pathname);
          cartDrawer.setActiveElement(document.activeElement);
        }

        let config;
        if (typeof fetchConfig === 'function') {
          config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
        } else {
          config = { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' } };
        }
        config.body = formData;

        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', config);

        if (!response.ok) {
          const err = await response.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'Failed to add to cart');
        }

        const data = await response.json();

        // renderContents updates the drawer HTML and opens it — no alert needed
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data, true);
        }

        // Uncheck recommendation checkboxes but keep current product checked
        this.checkboxes.forEach(cb => {
          if (!cb.closest('.product-recommendations__item--current')) cb.checked = false;
        });
        this.updateAddAllButtonState();
        this.updateCounter();

      } catch (error) {
        console.error('Error adding products to cart:', error);
        alert(error.message || 'There was an error adding products to cart. Please try again.');
      } finally {
        if (loadingSpinner) loadingSpinner.style.display = 'none';
        this.addAllButton.style.opacity = '1';
        this.addAllButton.style.pointerEvents = 'auto';
        this.updateAddAllButtonState();
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
